import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Container, Typography, Box, Grid } from '@mui/material';
import { getAllPosts, getPostsByTag } from '../utils/blog';
import BlogPostCard from '../components/Blog/BlogPostCard';
import TagChip from '../components/Blog/TagChip';

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  pageSubtitle: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    maxWidth: '600px',
    margin: `0 auto ${theme.spacing(4)}`,
  },
  activeFilter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
}));

const BlogListPage = () => {
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const tagFilter = searchParams.get('tag');

  const posts = tagFilter ? getPostsByTag(tagFilter) : getAllPosts();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 6 }}>
        <Typography variant="h2" className={classes.pageHeader}>
          Blog
        </Typography>

        <Typography variant="h6" className={classes.pageSubtitle}>
          Thoughts on projects, tools, and things I'm learning.
        </Typography>

        {tagFilter && (
          <Box className={classes.activeFilter}>
            <Typography variant="body2">Filtered by:</Typography>
            <TagChip tag={tagFilter} />
          </Box>
        )}

        {posts.length === 0 ? (
          <Typography variant="body1" align="center">
            No posts found.
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {posts.map((post) => (
              <Grid size={{ xs: 12, md: 6 }} key={post.slug}>
                <BlogPostCard post={post} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default BlogListPage;
